module.exports = __webpack_public_path__ + "img/interior_19.08bffa9e.png";